import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormControl } from '@angular/forms';

@Component({
    selector: 'tvcore-radio',
    templateUrl: './radio.component.html',
    styleUrls: ['./radio.component.scss'],
    standalone: false
})
export class RadioComponent implements OnInit {
	@Input()
	name: string;
	@Input()
	showErrors: boolean = false;
	@Input()
	value: any;
	@Input()
	theme: 'blue' | 'green' = 'blue';

	control: FormControl | null;

	constructor(private controlContainer: ControlContainer) {}

	ngOnInit() {
		this.control = this.controlContainer.control?.get(this.name) as FormControl;
	}

	hasError(): boolean {
		return this.showErrors && !!this.control?.invalid;
	}

	isActive(): boolean {
		return this.control?.value === this.value;
	}

	toggle(ev: Event) {
		ev.preventDefault();

		if (this.control) {
			this.control.setValue(this.value);
		}
	}
}
